export default [
    {
        code: '199',
        title: 'Starter',
        price: 0,
        features: [
            'All sports',
            'Most bookmakers',
            'All betting markets',
        ],
        non_features: [
            'Historical Odds',
        ],
        price_suffix: '',
        quota: '500 credits',
        quota_suffix: 'per month',
        product_type: 'api',
        visible_on_homepage: true,
    },
    {
        code: '370',
        title: '20K',
        price: 30,
        features: [
            'All sports',
            'All bookmakers',
            'All betting markets',
            'Historical Odds',
        ],
        non_features: [],
        price_suffix: 'per month, USD',
        quota: '20,000 credits',
        quota_suffix: 'per month',
        product_type: 'api',
        visible_on_homepage: true,
    },
    {
        code: '371',
        title: '100K',
        price: 59,
        features: [
            'All sports',
            'All bookmakers',
            'All betting markets',
            'Historical Odds',
        ],
        non_features: [],
        price_suffix: 'per month, USD',
        quota: '100,000 credits',
        quota_suffix: 'per month',
        product_type: 'api',
        visible_on_homepage: true,
    },
    {
        code: '372',
        title: '5M',
        price: 119,
        features: [
            'All sports',
            'All bookmakers',
            'All betting markets',
            'Historical Odds',
        ],
        non_features: [],
        price_suffix: 'per month, USD',
        quota: '5M credits',
        quota_suffix: 'per month',
        product_type: 'api',
        visible_on_homepage: true,
    },
    {
        code: '373',
        title: '15M',
        price: 249,
        features: [
            'All sports',
            'All bookmakers',
            'All betting markets',
            'Historical Odds',
        ],
        non_features: [],
        price_suffix: 'per month, USD',
        quota: '15M credits',
        quota_suffix: 'per month',
        product_type: 'api',
        visible_on_homepage: true,
    },
    {
        code: '356',
        title: '25M',
        price: 350,
        features: [
            'All sports',
            'All bookmakers',
            'All betting markets',
            'Historical Odds',
        ],
        non_features: [],
        price_suffix: 'per month, USD',
        quota: '25M credits',
        quota_suffix: 'per month',
        product_type: 'api',
        visible_on_homepage: false,
    },
    {
        code: '400',
        title: '50M',
        price: 650,
        features: [
            'All sports',
            'All bookmakers',
            'All betting markets',
            'Historical Odds',
        ],
        non_features: [],
        price_suffix: 'per month, USD',
        quota: '50M credits',
        quota_suffix: 'per month',
        product_type: 'api',
        visible_on_homepage: false,
    },
    {
        code: '402',
        title: '75M',
        price: 950,
        features: [
            'All sports',
            'All bookmakers',
            'All betting markets',
            'Historical Odds',
        ],
        non_features: [],
        price_suffix: 'per month, USD',
        quota: '75M credits',
        quota_suffix: 'per month',
        product_type: 'api',
        visible_on_homepage: false,
    },
    {
        code: '403',
        title: '100M',
        price: 1200,
        features: [
            'All sports',
            'All bookmakers',
            'All betting markets',
            'Historical Odds',
        ],
        non_features: [],
        price_suffix: 'per month, USD',
        quota: '100M credits',
        quota_suffix: 'per month',
        product_type: 'api',
        visible_on_homepage: false,
    },
    {
        code: '1999',
        title: 'Starter',
        price: 0,
        features: [
            'All sports',
            'All bookmakers',
            'All featured betting markets',
        ],
        price_suffix: '',
        quota: '500 visits*',
        quota_suffix: 'per month',
        product_type: 'widget',
        visible_on_homepage: true,
    },
    {
        code: '2001',
        title: 'Small',
        price: 20,
        features: [
            'All sports',
            'All bookmakers',
            'All featured betting markets',
        ],
        price_suffix: 'per month, USD',
        quota: '5,000 visits*',
        quota_suffix: 'per month',
        product_type: 'widget',
        visible_on_homepage: true,
    },
    {
        code: '2002',
        title: 'Medium',
        price: 100,
        features: [
            'All sports',
            'All bookmakers',
            'All featured betting markets',
        ],
        price_suffix: 'per month, USD',
        quota: '100,000 visits*',
        quota_suffix: 'per month',
        product_type: 'widget',
        visible_on_homepage: true,
    },
]